module.exports = __webpack_public_path__ + "fa-regular-400.woff2?2fa6bcb87bcf488cbc93e7391cb3373a";